$('.button').click(function(e){
  e.preventDefault();
  console.log('click button');
});
